<!-- 铺货查询 -->
<template>
  <div id="tablePage">
    <div id="MyShopGoods">
      <el-button :disabled="fastDisabled" type="primary" plain @click="fastClose">铺货撤销</el-button>
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
        >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column type="index" align="center" label="序号" width="120">
          <template slot-scope="scope">
            <div
              style="display: flex;
      justify-content: center;"
            >
              {{ scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="铺货时间">
        </el-table-column>
        <el-table-column prop="commodityName" align="center" label="交易品种">
        </el-table-column>
        <el-table-column prop="storageName" align="center" label="仓库名称">
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="铺货数量">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <div
              v-if="scope.row.isRevoke==='Y'"
              style="display: flex;
      justify-content: center;"
            >
              <!-- 撤单 -->
              <el-button type="text" @click="revoke(scope.row)">撤单</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="撤单"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="revokeOrder"
      >
        <span>您确定要撤单吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="revokeConfirm">确认</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 批量撤单 -->
      <el-dialog
        title="快捷撤单"
        :visible.sync="dialogVisible1"
        width="30%"
      >
        <span>您确定要撤单吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="fastClickNum>0" @click="fastCloseClick">确认</el-button>
          <el-button @click="dialogVisible1 = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/*global http protocol*/
import {
  mapGetters
} from 'vuex'
import {
  bus
} from '../../../../assets/js/trans/bus.js'
export default {
  name: 'MyShopGoods',
  props: ['flag', 'page'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      isNetWrong: false,
      tableData: [],
      // 是否撤单
      dialogVisible: false,
      // 分页
      pageData: {
        total: null,
        pageSizes: [5, 10, 20, 30, 40, 50, 60],
        pageSize: 20,
        currentPage: 1
      },
      // 订单号
      sOrderId: '',
      tetqTableWidth: {
        bsFlag: 80,
        orderPrice: 100,
        orderQuantity: 100,
        ocFlag: 110,
        orderType: 110,
        State: 80,
        stopLossPrice: 110
      },
      timer: null,
      multipleSelection: [],
      // 是否快速撤单
      dialogVisible1: false,
      fastClickNum: 0,
      fastClickSuccessNum: 0,
      fastClickErrorNum: 0,
      OrderFrontSum: {
        'bsFlag': '',
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'firmId': 0,
        'frozeFee': 0,
        'frozeMargin': 0,
        'holdDetailId': 0,
        'ocFlag': '',
        'orderId': 0,
        'orderStatus': 0,
        'orderType': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tradeDay': 0,
        'unDealQuantity': 0,
        'unitNumeral': 0,
        'updateTime': 0
      },
      typeValue: '',
      typeOptions: [{
        value: '1',
        label: '已委托'
      }, {
        value: '2',
        label: '已成交'
      }, {
        value: '3',
        label: '已撤单'
      }, {
        value: '4',
        label: '部分成交'
      }, {
        value: '5',
        label: '部分成交后撤单'
      }]
    }
  },
  computed: {
    ...mapGetters(['h_orderTime', 'sessionInfoGetter', 'commodityStrategyGetter']),
    fastDisabled() {
      if (this.multipleSelection.length > 0) {
        return false
      }
      return true
    }
  },
  watch: {
    flag() {
      protocol.param_getSpreadQuery.param.bsFlag = this.flag
      this.showData()
    },
    typeValue() {
      if (this.typeValue) {
        protocol.param_getSpreadQuery.param.orderStatus = [this.typeValue]
      } else {
        protocol.param_getSpreadQuery.param.orderStatus = null
      }
      this.showData()
    },
    h_orderTime() {
      this.showData()
    }
  },
  created() {
    // 兄弟通信
    bus.$on('refreshData', () => {
      this.showData()
    })
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  mounted() {
    this.showData()
    // if (!this.timer) {
    //   // this.timer = setInterval(() => {
    //   //   this.showData()
    //   // }, window.g.APP_RUNLOOP_TIME ? window.g.APP_RUNLOOP_TIME : 3000)
    // }
  },
  methods: {
    selectable(row, index) {
      return row.isRevoke === 'Y'
    },
    fastCloseClick() {
      const that = this
      // that.fastClickSuccessNum = 0
      // that.fastClickErrorNum = 0
      that.fastClickNum = 0
      const orderList = []
      for (const tableCellData of this.multipleSelection) {
        if (tableCellData.isRevoke === 'Y') {
          // if (that.fastClickNum == 0) {
          //   orderList = orderList + String(tableCellData.orderId)
          // } else {
          //   orderList = orderList + ',' + String(tableCellData.orderId)
          // }
          orderList.push(tableCellData.spreadGoodsId)
          that.fastClickNum++
          // const withdrawLimitOrder = JSON.parse(JSON.stringify(protocol.withdrawLimitOrder))
          // withdrawLimitOrder.data.orderId = tableCellData.orderId
          // http.postFront1(withdrawLimitOrder).then(response => {
          //   if (response.data && response.data.code == '0') {
          //     that.fastClickSuccessNum++
          //   } else {
          //     that.fastClickErrorNum++
          //   }
          //   that.isOVER()
          // })
        }
      }
      if (that.fastClickNum > 0) {
        that.fastClickNum = 0
        this.multipleSelection = []
        protocol.param_deleteBatchSpreadGoods.param.spreadGoodsIds = orderList
        http.postFront1(protocol.param_deleteBatchSpreadGoods).then(response => {
          if (response.data && response.data.code == '0') {
            setTimeout(() => {
              that.showData()
            }, window.g.Interface_latency_Time && 800)
            this.$message(response.data.message)
          } else {
            this.$message(response.data.message)
          }
          this.dialogVisible1 = false
        })
      }
    },
    // // 快捷下单结束
    // isOVER() {
    //   if (this.fastClickSuccessNum + this.fastClickErrorNum == this.fastClickNum) {
    //     this.dialogVisible1 = false
    //     this.toggleSelection()
    //     if (this.fastClickSuccessNum == this.fastClickNum) {
    //       this.$message('撤单成功')
    //     } else if (this.fastClickErrorNum == this.fastClickNum) {
    //       this.$message('撤单失败')
    //     } else {
    //       this.$message(`已成功撤单${this.fastClickSuccessNum}条,失败${this.fastClickErrorNum}条`)
    //     }
    //     this.fastClickSuccessNum = this.fastClickErrorNum = this.fastClickNum = 0
    //   }
    // },
    // 快捷撤单
    fastClose() {
      this.dialogVisible1 = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 更改选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table.toggleRowSelection(row)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    selectCommodityStrategy(commodityId) {
      for (const CommodityStrategy of this.commodityStrategyGetter) {
        if (commodityId == CommodityStrategy.commodityId) {
          return CommodityStrategy
        }
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--'
      }
    },
    /**
     * s :selectCommodityStrategy(c)
     */
    coinSmallDigital(s) {
      const minPriceChange = s.minPriceChange // 最小数量变动单位
      const minAmountChange = s.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        // symbolId: this.item.symbolId,
        // numStr: /^(\-)*(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + amountPoint + '}).*$') // 数量
      }
    },
    // 是否撤单
    revokeOrder(done) {
      const that = this
      this.$confirm('确认撤单吗？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocol.param_getSpreadQuery.param.firmId = this.sessionInfoGetter.firmId
      protocol.param_getSpreadQuery.param.page = this.pageData.currentPage - 1
      protocol.param_getSpreadQuery.param.size = '' + this.pageData.pageSize
      http.postFront1(protocol.param_getSpreadQuery).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            // this.OrderFrontSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        // that.modifyData(arrIndex, 'bsFlag', 'B', that.$t('message.Buy'), that.$t('message.Sell'))
        // that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        // const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        // stateList.forEach((item, index) => {
        //   that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        // })
        // 价格
        // arrIndex.allPrice = (Number(arrIndex.quantity) * Number(arrIndex.singlePrice) * that.selectCommodityStrategy(arrIndex.commodityId).unitNumeral).toFixed(that.coinSmallDigital(that.selectCommodityStrategy(arrIndex.commodityId)))
      })
      const nutableArr = this.multipleSelection
      this.tableData = arr
      const newTable = []
      for (const tableCell of nutableArr) {
        for (const newCell of arr) {
          if (tableCell.orderId === newCell.orderId) {
            newTable.push(newCell)
          }
        }
      }
      setTimeout(() => {
        that.toggleSelection(newTable)
      }, 0)
    },
    // 撤单
    revoke(obj) {
      this.dialogVisible = true
      this.sOrderId = obj.spreadGoodsId
    },
    revokeConfirm() {
      const that = this
      protocol.param_deleteSpreadGoods.param.spreadGoodsId = this.sOrderId
      http.postFront1(protocol.param_deleteSpreadGoods).then(response => {
        if (response.data) {
          this.$message(response.data.message)
          if (response.data && response.data.code == '0') {
            setTimeout(() => {
              that.showData()
            }, window.g.Interface_latency_Time && 800)
          }
        }
      })
      this.dialogVisible = false
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.param_getSpreadQuery.param.sort[0].direction = 'ASC'
      } else {
        protocol.param_getSpreadQuery.param.sort[0].direction = 'DESC'
      }
      protocol.param_getSpreadQuery.param.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.postFront1(protocol.param_getSpreadQuery).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.OrderFrontSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.param_getSpreadQuery.param.sort[0].property = str)
    }
  }
}
</script>

